import { useEffect, useState } from "react";
import { useDispatch } from "react-redux";
import { NavLink, Route, Switch } from "react-router-dom";
import CardCredit from "src/assets/CardCredit";
import CartonBoxIcon from "src/assets/CartonBox";
import CreditCardIcon from "src/assets/CreditCard";
import UserIcon from "src/assets/User";
import WrenchIcon from "src/assets/Wrench";
import { loadWarehouseMappingsWithNewWarehouseData } from "src/redux/actions/brightpearl";
import Config from "./Config";
import Customers from "./Customers";
import InventoryTransactions from "./InventoryTransactions";
import Orders from "./Orders";
import Product from "./Product";
import PurchaseOrders from "./PurchaseOrders";

const BrightPearl = () => {
  const [activeVisible, setActiveVisible] = useState(false);
  const [activeTop, setActiveTop] = useState(0);

  const dispatch = useDispatch();
  useEffect(() => {
    dispatch(loadWarehouseMappingsWithNewWarehouseData());
    sessionStorage.setItem("cartType", "brightpearl");
  }, []);

  const menuItems = [
    {
      name: "Setup",
      href: "/app/brightpearl",
      icon: <WrenchIcon />,
      component: <Config />,
      exact: true,
    },
    {
      name: "Orders",
      href: "/app/brightpearl/orders",
      icon: <CreditCardIcon />,
      component: <Orders />,
    },
    {
      name: "Purchase Orders",
      href: "/app/brightpearl/purchase-orders",
      icon: <CreditCardIcon />,
      component: <PurchaseOrders />,
    },
    {
      name: "Customers",
      href: "/app/brightpearl/customers",
      icon: <UserIcon />,
      component: <Customers />,
    },
    {
      name: "Products",
      href: "/app/brightpearl/products",
      icon: <CartonBoxIcon />,
      component: <Product />,
    },
    {
      name: "Inventory Transactions",
      href: "/app/brightpearl/inventory-transactions",
      icon: <CardCredit />,
      component: <InventoryTransactions />,
    },
  ];

  return (
    <>
      <div
        className="bg-white py-3 dk-shadow-sm"
        style={{
          minWidth: 240,
          borderRight: "1px solid rgba(0, 0, 0, 0.1)",
          zIndex: 9,
          position: "relative",
        }}
      >
        {activeVisible && (
          <div
            className="ease-in-out-back"
            style={{
              width: 8,
              height: "3.25rem",
              position: "absolute",
              right: 0,
              top: activeTop,
              backgroundColor: "#4962df",
            }}
          ></div>
        )}
        {menuItems.map((item, index) => (
          <NavLink
            exact
            to={item.href}
            className="text-decoration-none px-4 py-3 d-block dk-navlink dk-navlink-hover mb-2 ease-in"
            isActive={(match, location) => {
              if (!match) return false;
              setActiveVisible(true);
              setActiveTop(1 + (3.375 + 0.5) * index + "rem");
              return true;
            }}
            style={{
              fontWeight: 500,
              color: "black",
            }}
          >
            <span className="svg-icon-lg svg-baseline mr-3">{item.icon}</span>
            {item.name}
          </NavLink>
        ))}
      </div>
      <div className="w-100 h-100 overflow-auto" style={{ background: "#f6f6f6" }}>
        <Switch>
          {menuItems.map((item) => (
            <Route exact={item.exact} path={item.href}>
              {item.component}
            </Route>
          ))}
        </Switch>
      </div>
    </>
  );
};

export default BrightPearl;
